import axios, {AxiosError, isAxiosError, AxiosHeaders} from 'axios';

import {apiUrl} from '../../utils/constants';

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface CheckoutResponse {
  sessionId: string;
  url: string;
  amount: number;
  currency: string;
  requestId: string;
  error: string;
}

export interface BodyFormValues {
  amount: number;
  currency: string;
  requestId: string;
  successCallbackUrl: string;
  errorCallbackUrl: string;
  callbackUrl: string;
}

export const checkout = async (
  requestBody: BodyFormValues,
  headers: AxiosHeaders
): Promise<CheckoutResponse> => {
  try {
    const response = await api.post<CheckoutResponse>(
      '/v1/checkout/session',
      requestBody,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const axiosError = error as AxiosError<CheckoutResponse>;
      if (axiosError.response?.data?.error) {
        throw new Error(axiosError.response.data.error);
      }
    }
    throw new Error('An unexpected error occurred during checkout');
  }
};
